import { useEffect, useState } from 'react'
import { AnimatePresence } from 'framer-motion'

import { useMenuContext } from 'context/menu-context'
import { IconArrow } from 'components/icons/arrow'
import { Nav } from '..'
import { Button, MenuContainer } from './styled'
import { theme } from 'styles/theme'

export const MobileNav = () => {
  const [isOpen, setOpen] = useState(false)
  const { visibleSection } = useMenuContext()

  useEffect(() => {
    if (isOpen) {
      setOpen(false)
    }
  }, [visibleSection])

  const toggleMenu = () => {
    setOpen(v => !v)
  }

  return (
    <>
      <AnimatePresence>
        {isOpen && (
          <MenuContainer
            initial={{ translateY: '100%' }}
            animate={{
              translateY: 0,
              transition: {
                type: 'tween',
                duration: 0.3,
                ease: theme.easeValues.out,
              },
            }}
            exit={{
              translateY: '100%',
              transition: {
                type: 'tween',
                duration: 0.3,
                ease: theme.easeValues.in,
              },
            }}
          >
            <Nav />
          </MenuContainer>
        )}
      </AnimatePresence>
      <Button onClick={toggleMenu} $isOpen={isOpen}>
        <IconArrow />
      </Button>
    </>
  )
}
